module.exports = __webpack_public_path__ + "static/img/T7399.c849bf44.png";